import * as jQuery from 'jquery';
import Color from 'color';
import { __ } from '@wordpress/i18n';
import { local } from 'brownies';

const getPlyr = async () => {
  return import('plyr').then(({ default: Plyr }) => {
    return Plyr;
  });
};

const getSwiper = async () => {
  return import('swiper/bundle').then(({ default: Swiper }) => {
    return Swiper;
  });
};

const getApiFetch = async () => {
  return import('@wordpress/api-fetch').then(({ default: apiFetch }) => {
    return apiFetch;
  });
};

(function ($) {
  let w = window;
  let d = document;
  let $window = $(w);
  let $html = $('html');
  let $body = $('body');
  let $header = $('#header');
  let $headerInner = $header.find('.header_inner');
  let $main = $('#main');
  let $footer = $('#footer');
  let $nav = $('#nav');
  let $nav_i = $nav.find('li');
  let $menuTrigger = $('#menuTrigger');
  let windowH;
  let windowW;
  let headerH;
  let scrollT;
  let sauvScroll = 0;
  let scrollUp = false;
  let $adminBar = $('#wpadminbar');
  let has_adminBar = $body.hasClass('admin-bar');
  let adminBar_h = 0;
  let swiper_containers = [];
  let swipers = [];
  function update_dimensions() {
    windowH = $window.height();
    windowW = $window.width();
    headerH = $headerInner.height();
    update_adminbar();
    update_scroll();
    main_min_height();
  }
  const check_prog_scroll = () => {
    const $prog_parent = $('.page_header_prog_links');
    if ($prog_parent.length) {
      const $last_link = $prog_parent.find('a:last-child');
      if ($last_link.hasClass('is_active')) {
        $prog_parent.scrollLeft($prog_parent.get(0).scrollWidth);
      }
    }
  };
  check_prog_scroll();
  function update_scroll() {
    if ($window.scrollTop() < scrollT || $window.scrollTop() < 150) {
      scrollUp = true;
    } else {
      scrollUp = false;
    }
    scrollT = $window.scrollTop();
  }

  function update_adminbar() {
    $adminBar =
      !$adminBar.length && has_adminBar ? $('#wpadminbar') : $adminBar;
    adminBar_h =
      $adminBar.length && $adminBar.is(':visible') ? $adminBar.height() : 0;
  }
  function main_min_height() {
    $main.css(
      'min-height',
      windowH - $footer.outerHeight() - $nav.outerHeight()
    );
  }
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On scroll
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var ticking = false;
  $window
    .on('scroll', function (event) {
      update_scroll();
      requestTick();
    })
    .trigger('scroll');

  function requestTick() {
    if (!ticking) {
      ticking = true;
      w.requestAnimationFrame(trigger_scroll);
    }
  }

  function trigger_scroll() {
    ticking = false;
    maj_header();
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Scroll jusqu'a un element
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function scrollToEl($el) {
    update_dimensions();
    var offsetEl = 0;
    if ($el.length) {
      offsetEl = $el.offset().top - adminBar_h;
      if (offsetEl < scrollT) {
        offsetEl -= headerH;
      }
    }
    scrollToOffset(offsetEl);
  }

  function scrollToOffset(offsetEl) {
    $('html, body').animate(
      {
        scrollTop: offsetEl,
      },
      300
    );
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // Menu
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $nav_links = $nav.find('.nav_link');
  var $nav_items = $nav.find('.nav_i');
  $nav_links.each(function (idx, el) {
    $(el).on('click', trigger_nav_link);
  });

  function trigger_nav_link(event) {
    var $this = $(this);
    var $link_item = $this.closest('.nav_i');
    var $sub_menu = $link_item.find('.nav_sub');
    if ($sub_menu.length) {
      event.preventDefault();
    }
    if ($link_item.hasClass('is-open')) {
      $link_item.removeClass('is-open');
      if ($sub_menu.length) {
        $html.removeClass('has-subnavOpen');
      }
    } else {
      $nav_items.removeClass('is-open');
      $link_item.addClass('is-open');
      if ($sub_menu.length) {
        $html.addClass('has-subnavOpen');
      }
    }
  }

  function closeSubMenu() {
    $html.removeClass('has-subnavOpen');
    $nav_items.removeClass('is-open');
    if ($html.hasClass('has-menuMobilOpen')) {
      $html.removeClass('has-menuMobilOpen');
    }
  }

  $nav.find('.search_form').on('submit', function (event) {
    var $form = $(this);
    event.preventDefault();
    $form.find(':focus').blur();
    closeSubMenu();
    ajax_load_page($form.attr('action') || window.location.href, false, {
      type: $form.attr('method') || 'get',
      data: $form.serialize() + '&is_ajax=1',
    });
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu mobile
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var menuMobilTrigger = $('#menuTrigger');
  if (menuMobilTrigger.length) {
    menuMobilTrigger.on('click', trigger_menu_mobil);
  }

  function trigger_menu_mobil(e) {
    e.preventDefault();
    if ($html.hasClass('has-menuMobilOpen')) {
      $html.removeClass('has-menuMobilOpen');
      menuMobilTrigger.removeClass('is-active');
      window.scrollTo(0, sauvScroll);
    } else {
      sauvScroll = scrollT;
      menuMobilTrigger.addClass('is-active');
      $html.addClass('has-menuMobilOpen');
    }
  }
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On resize
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $window
    .on('resize', function (event) {
      update_dimensions();
      maj_header();
      check_prog_scroll();
    })
    .trigger('resize');

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Sticky header
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function maj_header() {
    if (scrollT > 80) {
      $header.find('.header_inner').removeClass('is-transparent');
    } else {
      $header.find('.header_inner').addClass('is-transparent');
    }
    if (scrollUp) {
      $html.removeClass('is-nav-slided');
    } else {
      $html.addClass('is-nav-slided');
    }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Select cinema
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $body.find('.js-select-redirect').on('change', function (event) {
    if ($(this).val() != '') {
      document.location.href = $(this).val();
    }
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Init accordéons
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  const toggle_acc = ($acc, $cont) => {
    const $acc_head = $acc.find('.acc_head');
    const $acc_content = $acc.find('.acc_content');
    const id = $acc_head.attr('id');
    const is_open = $acc.hasClass('is-active');
    $acc.toggleClass('is-active');
    $acc_head.attr('aria-selected', !is_open);
    $acc_content.attr('aria-expanded', !is_open);
    $acc_content[is_open ? 'slideUp' : 'slideDown']({
      duration: 300,
    });
    $acc_content.attr('aria-hidden', is_open);
    // Si l’accordéon était fermé, ça veut dire qu'on ferme les autres.
    if (!is_open) {
      const $accs = $cont.find('.acc');
      $accs.not($acc).each((idx, el) => {
        const $el = $(el);
        close_acc($el);
      });
    }
  };

  const close_acc = ($acc) => {
    const $acc_head = $acc.find('.acc_head');
    const $acc_content = $acc.find('.acc_content');
    $acc.removeClass('is-active');
    $acc_head.attr('aria-selected', false);
    $acc_content.attr('aria-expanded', false);
    $acc_content.slideUp({
      duration: 300,
      queue: false,
    });
  };
  const accs_init = ($cont) => {
    const $accs = $cont.find('.acc');
    $accs.each((idx, el) => {
      const $el = $(el);
      const $acc_head = $el.find('.acc_head');
      const $acc_content = $el.find('.acc_content');

      $el.attr('id', `acc-${idx}`);
      $acc_head.attr('id', `tab-${idx}`);
      $acc_head.attr('aria-controls', `pan-${idx}`);
      $acc_content.attr('id', `pan-${idx}`);
      $acc_content.attr('aria-labelledby', `tab-${idx}`);
      $el.find('.acc_head').on('click', (e) => {
        onClickAcc(e, $cont);
      });
    });
  };
  const onClickAcc = (e, $cont) => {
    const $acc_head = $(e.currentTarget);
    const $acc = $acc_head.closest('.acc');
    toggle_acc($acc, $cont);
  };
  accs_init($body);

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Carte Google
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  const colors = document.theme_settings
    ? theme_settings?.colors
    : [{ slug: 'beige', color: '#C6B6A8' }];
  const accent_color = Color(
    colors.find((color) => color.slug === 'beige')?.color
  );
  const light_accent_color = accent_color.lighten(0.1);
  const dark_accent_color = accent_color.darken(0.5);
  const darker_accent_color = accent_color.darken(0.5);
  var $maps = $main.find('.cine_map'),
    $mapsMarker = $main.find('.cine_card'),
    pageMap = null,
    maps_items = [],
    maps_infowindow = null,
    maps_styles = [
      {
        featureType: 'administrative',
        elementType: 'all',
        stylers: [{ visibility: 'simplified' }],
      },
      {
        featureType: 'administrative',
        elementType: 'labels.text',
        stylers: [{ color: darker_accent_color.hex() }],
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
          { visibility: 'simplified' },
          { color: light_accent_color.hex() },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ visibility: 'simplified' }, { color: accent_color.hex() }],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{ visibility: 'simplified' }, { color: accent_color.hex() }],
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [{ visibility: 'simplified' }, { color: accent_color.hex() }],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          { visibility: 'simplified' },
          { color: dark_accent_color.hex() },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels',
        stylers: [{ visibility: 'simplified' }, { color: accent_color.hex() }],
      },
    ];

  function maps_get_icon(color, width) {
    // https://stackoverflow.com/questions/24413766/how-to-use-svg-markers-in-google-maps-api-v3
    width = width || 10;
    var template = [
      '<?xml version="1.0"?>',
      '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' +
        width +
        ' ' +
        width +
        '" width="' +
        width +
        'px" height="' +
        width +
        'px">',
      '<circle fill="{{color}}" cx="' +
        width * 0.5 +
        '" cy="' +
        width * 0.5 +
        '" r="' +
        width * 0.5 +
        '"/>',
      '<circle fill="#FFFFFF" cx="' +
        width * 0.5 +
        '" cy="' +
        width * 0.5 +
        '" r="' +
        width * 0.35 +
        '"/>',
      '</svg>',
    ].join('\n');
    var svg = template.replace('{{color}}', color);
    return maps_encode_icon(svg);
  }

  // Icone encodée
  function maps_encode_icon(icon) {
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon);
  }

  // Icone google map
  function maps_pinSymbol(color, width) {
    return {
      url: maps_get_icon(color, width),
      scaledSize: new google.maps.Size(width, width),
    };
  }

  function maps_init() {
    var gmapcallback = function () {
      if (!$maps.length) return;
      maps_setup();
    };
    window.gmapcallback = gmapcallback;
    if (!$maps) return;
    $maps.addClass('map_disabled');
    $maps.append(
      '<p>Pour utiliser la carte, veuillez accepter les cookies de Google Maps.</p>'
    );
    document.addEventListener('googlemaps_loaded', function () {
      $maps.find('p').remove();
      $maps.removeClass('map_disabled');
    });
  }
  maps_init();

  function maps_setup() {
    if (!$maps.length) return;
    $maps.each(function (idx, gogomap) {
      maps_render(gogomap);
    });
  }

  function maps_render(gogomap) {
    // Réglages de base
    pageMap = new google.maps.Map(gogomap, {
      zoom: 10,
      // maxZoom: 17,
      center: new google.maps.LatLng(46.7157498, -1.8145941),
      // scrollwheel : false,
      gestureHandling: 'cooperative',
      // draggable : true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: maps_styles,
      streetViewControl: false,
      overviewMapControl: false,
      mapTypeControl: false,
      panControl: false,
      // scaleControl : false,
      zoomControlOptions: { style: google.maps.ZoomControlStyle.SMALL },
    });

    maps_infowindow = new google.maps.InfoWindow({ maxWidth: 205 });
    google.maps.event.addListener(pageMap, 'click', function () {
      maps_infowindow.close();
    });
    google.maps.event.addDomListener(window, 'resize', function () {
      maps_update_bounds();
    });

    maps_get_items();
    maps_set_markers();
  }

  function maps_get_items() {
    $mapsMarker.each(function (idx, el) {
      var $el = $(el);
      var itemMarker = null;
      var itemInfos = {
        title: $el.find('h3').html(),
        seances: $el.find('a.cine_card_seances').attr('href'),
        events: $el.find('a.cine_card_events').attr('href'),
        infos: $el.find('a.cine_card_infos').attr('href'),
        lat: $el.data('lat') ? parseFloat($el.data('lat')) : false,
        lng: $el.data('lng') ? parseFloat($el.data('lng')) : false,
      };

      if (itemInfos.title && itemInfos.lat && itemInfos.lng) {
        itemMarker = new google.maps.Marker({
          title: itemInfos.title,
          position: { lat: itemInfos.lat, lng: itemInfos.lng },
          icon: maps_pinSymbol('#222F7B', 30),
          optimized: false,
          othersDatas: $.extend({}, itemInfos),
        });
        itemInfos['marker'] = itemMarker;
        maps_items.push(itemInfos);
      }
    });
  }

  function maps_set_markers() {
    if (!pageMap || !maps_items || !maps_items.length) {
      return;
    }

    // var bounds = new google.maps.LatLngBounds();
    $.each(maps_items, function (idx, item) {
      item.marker.setMap(pageMap);
      // bounds.extend(item.marker.position);
      google.maps.event.addListener(item.marker, 'click', maps_open_info);
    });
    // pageMap.fitBounds(bounds);
    maps_update_bounds();
  }

  function maps_open_info(e, marker) {
    marker = marker || this;
    var datas = marker.othersDatas;
    var infoHtml = '<div class="gmInfo">';
    if (datas.title)
      infoHtml += '<h3 class="gmInfo_title">' + datas.title + '</h3>';
    infoHtml += '<div class="gmInfo_links">';
    if (datas.seances)
      infoHtml +=
        '<a href="' + datas.seances + '">' + __('Les séances', 'grac') + '</a>';
    if (datas.events)
      infoHtml +=
        '<a href="' +
        datas.events +
        '">' +
        __('Les événements', 'grac') +
        '</a>';
    if (datas.infos)
      infoHtml +=
        '<a href="' +
        datas.infos +
        '">' +
        __('Les infos pratiques', 'grac') +
        '</a>';
    infoHtml += '</div>';
    infoHtml += '</div>';
    maps_infowindow.setContent(infoHtml);
    maps_infowindow.open(pageMap, marker);
  }

  function maps_update_bounds() {
    if (!pageMap || !maps_items.length) return;

    var bounds = new google.maps.LatLngBounds();
    $.each(maps_items, function (idx, item) {
      // if(!map_filters || $.inArray(item.filter, map_filters) === -1) {
      bounds.extend(item.marker.position);
      // }
    });
    pageMap.fitBounds(bounds);
  }

  $('.cine_card a[href^="#cinema-"]').on('click', function (event) {
    event.preventDefault();
    var $target = $($(this).attr('href'));
    var target_index = $target.index('.cine_card');
    scrollToEl($maps);
    if (
      $target.length &&
      maps_items &&
      maps_items[target_index] &&
      maps_items[target_index].marker
    ) {
      maps_open_info(false, maps_items[target_index].marker);
    }
  });

  $main.on('click', '.gmInfo a[href^="#cinema-"]', function (event) {
    event.preventDefault();
    var $target = $($(this).attr('href'));
    scrollToEl($target);
  });

  if (window.location.hash != '') {
    var $openCineCard = $('.cine_card' + window.location.hash);
    if ($openCineCard.length) {
      $openCineCard.find('.acc_head').trigger('click');
    }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Tarte au citron (Bandeau RGPD)
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  tarteaucitronCustomText = {
    acceptAll: 'Accepter',
    denyAll: 'Refuser',
    alertBigPrivacy:
      'Ce site utilise des cookies et vous donne le<br/>contrôle sur ceux que vous souhaitez activer',
  };
  tarteaucitron.init({
    privacyUrl: '' /* Privacy policy url */,

    hashtag: '#rgpd' /* Open the panel with this hashtag */,
    cookieName: 'rgpd' /* Cookie name */,

    orientation: 'bottom' /* Banner position (top - bottom) */,
    showAlertSmall: false /* Show the small banner on bottom right */,
    cookieslist: true /* Show the cookie list */,

    adblocker: false /* Show a Warning if an adblocker is detected */,
    AcceptAllCta: true /* Show the accept all button when highPrivacy on */,
    DenyAllCta: true,
    highPrivacy: true /* Disable auto consent */,
    handleBrowserDNTRequest: false /* If Do Not Track == 1, disallow all */,

    removeCredit: true /* Remove credit link */,
    moreInfoLink: false /* Show more info link */,
    useExternalCss: false /* If false, the tarteaucitron.css file will be loaded */,

    readmoreLink: '' /* Change the default readmore link */,

    mandatory: false /* Show a message about mandatory cookies */,
  });

  // (tarteaucitron.job = tarteaucitron.job || []).push("youtube");

  // (tarteaucitron.job = tarteaucitron.job || []).push("vimeo");

  tarteaucitron.user.googlemapsKey = 'AIzaSyDmT6hoGXEaovyAu6cp4Ip5ihDp21wW3-E';
  tarteaucitron.user.mapscallback = 'gmapcallback';
  tarteaucitron.user.hasgooglemaps = $maps.length > 0;
  (tarteaucitron.job = tarteaucitron.job || []).push('googlemaps');

  // document.addEventListener("youtube_allowed", function (_) {
  // 	window.inityoutubevideos();
  // });
  // document.addEventListener("youtube_added", function (_) {
  // 	window.inityoutubevideos();
  // });

  // document.addEventListener("vimeo_allowed", function (_) {
  // 	window.initvimeovideos();
  // });
  // document.addEventListener("vimeo_added", function (_) {
  // 	window.initvimeovideos();
  // });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Agenda bas de page
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  let $agenda = $('.agenda');
  let $agenda_swiper = $('.agenda_jours');
  let $agenda_events = $('.agenda_events').find('li');
  let $agenda_close = $('.agenda_close');
  let $jours = $agenda_swiper.find('li');
  if ($agenda.length) { $body.addClass('has-agenda'); }
  const agenda_init = async () => {
    if (!$agenda_swiper.length) return;
    $body.addClass('has-agenda');
    const Swiper = await getSwiper();
    let swiper = new Swiper('.agenda_jours', {
      slidesPerView: 2,
      spaceBetween: 15,
      slidesPerGroup: 2,
      freeMode: true,
      navigation: {
        nextEl: '.agenda_button-next',
        prevEl: '.agenda_button-prev',
      },
      breakpoints: {
        375: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20,
        },
        475: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 20,
        },
        575: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 20,
        },
        775: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 20,
        },
        875: {
          slidesPerView: 6,
          slidesPerGroup: 6,
          spaceBetween: 20,
        },
        925: {
          slidesPerView: 6,
          slidesPerGroup: 6,
          spaceBetween: 28,
        },
      },
    });
    $agenda_swiper.data('swiper', swiper);
  };

  const agenda_load = async (cinema_id) => {
    let res = '';
    const params = new URLSearchParams();
    params.set('id', cinema_id);
    agenda_close();
    let swiperInstance = $agenda_swiper.data('swiper');
    if (swiperInstance) {
      swiperInstance.destroy(true, false);
    }
    $agenda_swiper.find('.swiper-wrapper').html('');
    $('.agenda_events').html('');
    $('.agenda_button').addClass('is-empty');
    const apiFetch = await getApiFetch();
    apiFetch({
      path: `grac/v1/get_agenda_items?${params.toString()}`,
    })
      .then((res) => {
        if (res.days && res?.detail && res?.slider) {
          $('.agenda_button').removeClass('is-empty');
          $agenda_swiper.find('.swiper-wrapper').html(res.slider);
          $('.agenda_events').html(res.detail);
          $jours = $agenda_swiper.find('li');
          $agenda_events = $('.agenda_events').find('li');
          agenda_init();
        } else {
          $agenda_swiper
            .find('.swiper-wrapper')
            .html('<h2>Aucun résultat.</h2>');
        }
      })
      .catch((err) => {
        console.log('err_agenda', err);
      });
  };

  if (local && local.agenda_cinema && Number.isInteger(local.agenda_cinema)) {
    $body.find('.js-select-agenda:has(option[value="'+local.agenda_cinema+'"])').val(local.agenda_cinema);
    agenda_load(local.agenda_cinema);
  }

  const insert_cinemas = () => {
    if (local?.selected_cinemas) {
      let params = new URLSearchParams(document.location.search);
      let cinema_param = params.get("cinema");
      let cinema_option = $('.js-select-cinema').find('option[data-slug="'+cinema_param+'"]');
      if (cinema_option.length>0) {
        const values = cinema_option.val().split('__');
        const id = values[0];
        const name = values[1];
        local.selected_cinemas = [{
          id: id,
          name: name
        }];
      }

      let html = '';
      $('.js-select-cinema').find('option').attr('disabled', false);
      if (local.selected_cinemas?.length) {
        local.selected_cinemas.forEach((cinema) => {
          $('.js-select-cinema')
            .find('option[data-id="' + cinema.id + '"')
            .attr('disabled', true);
          if (cinema.id && cinema.name) {
            html += `<button data-id="${cinema.id}">${cinema.name}</button>`;
          }
        });
      } else {
        // $body.find('.js-select-cinema').val('');
        // html = `<p>Aucun cinéma sélectionné.</p>`;
        // $('.seances-inner').html('');
        get_seances_without_cinemas();
      }
      $body.find('.selected_cinemas').html(html);
    }
  };

  const get_seances_without_cinemas = async () => {
    if (typeof post_id !== 'undefined' && post_id) {
      const apiFetch = await getApiFetch();
      const params = new URLSearchParams();

      params.set('post_id', post_id);
      apiFetch({
        path: `grac/v1/get_seances?${params.toString()}`,
      })
        .then((res) => {          
          if (res?.html) {
            $('.seances-inner').html(res.html);
          }
          if ($('.event_elsewhere').length) {
            if (res?.elsewhere) {
              $('.event_elsewhere').html(res.elsewhere);
            } else {
              $('.event_elsewhere').html('');
            }
          }
        })
        .catch((err) => {
          console.log('err_events', err);
        });
    }
    else {
      update_seances();
    }
  }

  const update_seances = async () => {
    if (local?.selected_cinemas && typeof post_id !== 'undefined' && post_id) {
      let html = '';
      if (local.selected_cinemas?.length) {
        const apiFetch = await getApiFetch();
        const params = new URLSearchParams();
        local.selected_cinemas.forEach((cinema) => {
          params.append('id[]', cinema.id);
        });
        params.set('post_id', post_id);
        apiFetch({
          path: `grac/v1/get_seances?${params.toString()}`,
        })
          .then((res) => {
            if (res?.html) {
              $('.seances-inner').html(res.html);
            }
            if ($('.event_elsewhere').length) {
              if (res?.elsewhere) {
                $('.event_elsewhere').html(res.elsewhere);
              } else {
                $('.event_elsewhere').html('');
              }
            }
          })
          .catch((err) => {
            console.log('err_events', err);
          });
      }
    } 
    else if ($main.find('.programmation')) {
      if (typeof edition_id !== 'undefined' && edition_id) {
        let $prog_article = $main.find('.programmation');
        const apiFetch = await getApiFetch();
        const params = new URLSearchParams();
        params.set('edition', edition_id);
        const cinemas = local.selected_cinemas || [];
        cinemas.forEach((cinema) => {
          params.append('id[]', cinema.id);
        });
        if ($('.js-select-jour').val()) {
          params.set('from_date', $('.js-select-jour').val());
          params.set('to_date', $('.js-select-jour').val());
        }
        if ($('.js-select-age').val()) {
          params.set('age', $('.js-select-age').val());
        }
        if ($prog_article.hasClass('prog-films')) {
          apiFetch({
            path: `grac/v1/get_cinema_movies?${params.toString()}`,
          })
            .then((res) => {
              if (res?.html) {
                $('.prog_movies_grid').html(res.html);
              }
            })
            .catch((err) => {
              console.log('err_prog_movies', err);
            });
        } else if ($prog_article.hasClass('prog-evenements')) {
          if ($('.js-select-type').val()) {
            params.set('type', $('.js-select-type').val());
          }
          if ($('.js-select-age').val()) {
            params.set('age', $('.js-select-age').val());
          }
          apiFetch({
            path: `grac/v1/get_cinema_events?${params.toString()}`,
          })
            .then((res) => {
              if (res?.html) {
                $('.prog_events_list').html(res.html);
              }
            })
            .catch((err) => {
              console.log('err_prog_events', err);
            });
        }
      }
    }
  };

  if ($body.find('.js-select-cinema').length) {
    $body.on('change', '.js-select-cinema', function (_) {
      if ($(this).val() != '') {
        const values = $(this).val().split('__');
        const id = values[0];
        const name = values[1];
        let newCinemas = [];
        if (local?.selected_cinemas?.length) {
          newCinemas = [...local.selected_cinemas];
        }
        newCinemas.push({ id, name });
        local.selected_cinemas = newCinemas;
        update_seances();
        insert_cinemas();
      }
    });
    $body.on('click', '.selected_cinemas button', function (event) {
      let $this = $(this);
      let id = $this.data('id');
      let newCinemas = [];
      if (local?.selected_cinemas?.length) {
        newCinemas = [...local.selected_cinemas];
      }
      newCinemas = newCinemas.filter((cinema) => cinema.id != id);
      local.selected_cinemas = newCinemas;
      update_seances();
      insert_cinemas();
    });
    insert_cinemas();
    update_seances();
  }

  if ($body.find('.js-select-cinema-link').length) {
    $('.js-select-cinema-link').on('change', function (e) {
      if ($(this).val() != '') {
        const values = $(this).val().split('__');
        const id = values[0];
        const name = values[1];
        let newCinemas = [];
        const found = local?.selected_cinemas?.some(
          (cinema) => cinema.id == id
        );
        if (!found) {
          if (local?.selected_cinemas?.length) {
            newCinemas = [...local.selected_cinemas];
          }
          newCinemas.push({ id, name });
          local.selected_cinemas = newCinemas;
        }
        if (url?.prog_url) {
          document.location.href = url.prog_url;
        }
      }
    });
  }

  $body.find('.js-select-jour, .js-select-type, .js-select-age').on('change', function (event) {
    update_seances();
  });

  $body.find('.js-select-agenda').on('change', function (event) {
    if ($(this).val() != '') {
      local.agenda_cinema = Number($(this).val());
      agenda_load(Number($(this).val()));
    }
  });

  const swiper_socials = async () => {
    const $socials_container = $('.socials_container');
    if ($socials_container.length) {
      const Swiper = await getSwiper();
      let swiper = new Swiper('.social_wrapper', {
        spaceBetween: 20,
        slidesPerView: 2.2,
        autoHeight: true,
        breakpoints: {
          768: {
            slidesPerView: 3.5,
          },
        },
      });
    }
  };
  swiper_socials();

  $body.on('click', '.agenda_jours li', function (event) {
    let $this = $(this);
    let opened = $this.hasClass('selected');
    $jours.removeClass('selected');
    if ($this.hasClass('agenda_jours-hasdate')) {
      // Récupère l'attribut data-jour
      let jour = $this.data('jour');
      if (opened) {
        agenda_close(jour);
      } else {
        $this.addClass('selected');
        agenda_show(jour);
      }
      $agenda_close.removeClass('agenda_close-hidden');
    }
    if ($('.agenda_events').find('li').filter('.is_visible').length > 0) {
      $agenda_close.removeClass('agenda_close-hidden');
    } else {
      $agenda_close.addClass('agenda_close-hidden');
    }
  });

  $agenda_close.on('click', function (event) {
    agenda_close();
  });

  function agenda_show(jour) {
    $('.agenda_events')
      .find('li')
      .filter(':not([data-jour="' + jour + '"])')
      .removeClass('is_visible');
    if (
      $('.agenda_events')
        .find('li')
        .filter('[data-jour="' + jour + '"]')
        .hasClass('is_visible')
    ) {
      agenda_close(jour);
    } else {
      $('.agenda_events')
        .find('li')
        .filter('[data-jour="' + jour + '"]')
        .addClass('is_visible');
    }
  }

  function agenda_close(jour) {
    $jours.removeClass('selected');
    if (jour != null) {
      $agenda_events
        .filter('[data-jour="' + jour + '"]')
        .removeClass('is_visible');
    } else {
      $agenda_events.filter('.is_visible').removeClass('is_visible');
    }
    $agenda_close.addClass('agenda_close-hidden');
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // Bande-annonce
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  const $seances_button = $('.bloc-bande_annonce_seances');
  const $ba_buttons = $('.bloc-bande_annonce_button');
  $ba_buttons.on('click', function (e) {
    onClickBaButton(e);
  });
  $seances_button.on('click', function () {
    const $seances_container = $('.film-seances');
    scrollToEl($seances_container);
  });
  const $ba_button = $('.bloc-bande_annonce_button[data-src]');
  if ($ba_button.length) {
    $ba_button.each(function (idx, el) {
      const $el = $(el);
      $el.attr(`data-ba`, idx);
      const src = $el.data('src');
      const poster = $el.data('poster');
      $body.append(`
        <div aria-live="polite" data-ba=${idx} class="ba-container is-hidden" aria-hidden="true">
          <video id="" playsinline controls data-poster="${poster}">
            <source src="${src}" type="video/mp4" />
          </video>
          <button class="close_ba"><span class="srOnly">Fermer la bande-annonce</span></button>
        </div>
      `);
    });
  }

  const onClickBaButton = (e) => {
    const $btn = $(e.currentTarget);
    const ba_id = $btn.attr('data-ba');
    if (!ba_id) {
      return false;
    }
    openVideoContainer(ba_id);
  };

  const openVideoContainer = (ba_id) => {
    $html.addClass('is-scroll-blocked');
    const $video_container = $body.find(`.ba-container[data-ba="${ba_id}"]`);
    $video_container.find('.close_ba').on('click', function () {
      closeVideoContainer(ba_id);
    });
    $video_container.on('click', function (e) {
      if (e.target === e.currentTarget) {
        closeVideoContainer(ba_id);
      }
    });
    const $plyr = $video_container.find('.plyr');
    if (!$plyr.length || !$plyr.hasClass('is-init')) {
      initVideoPlayer(ba_id);
    }
    $video_container.removeClass('is-hidden');
  };

  const closeVideoContainer = (ba_id) => {
    $html.removeClass('is-scroll-blocked');
    const $video_container = $body.find(`.ba-container[data-ba="${ba_id}"]`);
    const $plyr = $video_container.find('.plyr');
    const player = $plyr.data('player');
    player.pause();
    $video_container.find('.close_ba').off('click');
    $video_container.off('click');
    $video_container.addClass('is-hidden');
  };

  const initVideoPlayer = async (ba_id) => {
    const $video_container = $body.find(`.ba-container[data-ba="${ba_id}"]`);
    const Plyr = await getPlyr();
    const player = new Plyr(`.ba-container[data-ba="${ba_id}"] video`, {
      controls: [
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'fullscreen',
      ],
    });
    const $plyr = $video_container.find('.plyr');
    $plyr.addClass('is-init');
    $plyr.data({ player });
  };

  const init_nl_form = (ba_id) => {
    const $nl_form = $body.find(`.nl_form`);
    if ($nl_form.length) {
      $nl_form.on('submit', async (e) => {
        e.preventDefault();
        const $input = $nl_form.find('input[name="email"]');
        const email = $input.val();
        if (!email) {
          return false;
        }
        const apiFetch = await getApiFetch();
        apiFetch({ path: `/grac/v1/newsletter_signup?email=${email}` }).then(
          (res) => {
            if (res && res.data) {
              const $message = $nl_form.find('.nl_form_message');
              $message.text('Inscription effectuée avec succès.');
              $input.val('');
            } else {
              $message.text(
                'Une erreur est survenue lors de votre inscription.'
              );
            }
          }
        );
      });
    }
  };
  init_nl_form();
})(jQuery);
